<svg xmlns="http://www.w3.org/2000/svg" [attr.width]="widthHeight" [attr.height]="widthHeight" viewBox="0 0 52 52">
  <g data-name="Group 31393" transform="translate(-.028 -.041)">
    <circle data-name="Ellipse 2256" cx="26" cy="26" r="25" transform="translate(.028 .041)" [style.fill]="bgColor"  
      [style.stroke]="borderColor"  [style.stroke-width]="borderWidth"/>
    <g data-name="tick (4)">
      <g data-name="Group 2944">
        <path data-name="Path 69937" d="M24.651 68.364a1.251 1.251 0 0 0-1.769 0L7.9 83.351 2.135 77.59a1.251 1.251 0 0 0-1.769 1.769L7.011 86a1.251 1.251 0 0 0 1.769 0l15.871-15.867a1.251 1.251 0 0 0 0-1.769z" transform="translate(14.063 -50.594)" 
          style="stroke-width:1px" [style.fill]="tickColor" [style.stroke]="tickColor" 
        />
      </g>
    </g>
  </g>
</svg>